<template>
  <div>
    <div class="container mx-auto max-w-4xl px-4 pb-8 pt-4">
      <slot />
    </div>
  </div>
</template>
